import React, { Component } from 'react';
import classNames from 'classnames';
import { withContext } from '../utils/StateProvider';
import FacilityFrame from './facilityFrame';
import { healCost, pointsNeeded, templeBlocker, REVIVE_BASE, REVIVE_PER_LEVEL, HEAL_PER_HP } from '../utils/services';

// The temple: healing sold by the hit point, and the dead raised for a levy.
class Temple extends Component {

  handleKeydown = (e) => {
    const { party, healAtTemple } = this.props.context;
    const slot = parseInt(e.key, 10) - 1;
    if (slot >= 0 && slot < party.length) healAtTemple(slot);
  }

  // What this character needs doing, in the priests' words
  describe(character) {
    if (character.condition === 'dead') {
      return `dead · the rite costs ${REVIVE_BASE} plus ${REVIVE_PER_LEVEL} a level`;
    }
    const points = pointsNeeded(character);
    if (!points && character.condition === 'good') return 'hale and whole';
    const wounds = `${points} hit points short at ${HEAL_PER_HP} gold each`;
    return character.condition === 'unconscious' ? `senseless · ${wounds}` : wounds;
  }

  render() {
    const { facility, party, gold, healAtTemple } = this.props.context;
    if (facility !== 'temple') return null;

    return (
      <FacilityFrame
        title="The Temple"
        quote='"No wound is beyond us. No purse is beyond us either."'
        hint="Click a rite or press 1-6 · the price follows the injury"
        onKey={this.handleKeydown}
      >
        <div className="training-list">
          {party.map((c, index) => {
            const cost = healCost(c);
            const blocker = templeBlocker(c, gold);
            const raising = c.condition === 'dead';
            return (
              <div key={c.id} className={classNames('training-row', { ready: !blocker })}>
                <span className="training-slot">{index + 1}</span>
                <div className="training-who">
                  <div className="training-name">
                    {c.name} <span className="sheet-muted">{c.className} {c.level}</span>
                  </div>
                  <div className="sheet-muted">{c.hp}/{c.maxHp} HP · {this.describe(c)}</div>
                </div>
                <button
                  className={classNames('menu-button', 'small', { disabled: !!blocker })}
                  onClick={() => healAtTemple(index)}
                >
                  {cost ? `${raising ? 'RAISE' : 'HEAL'} · ${cost}g` : 'WELL'}
                </button>
              </div>
            );
          })}
        </div>
      </FacilityFrame>
    );
  }
}

export default withContext(Temple);
